"use client";

export { default } from "./studio/StudioScreenRenderer";
export type { StudioScreenRendererProps } from "./studio/StudioScreenRenderer";
